import React from "react";

// import "react-phone-input-2/lib/material.css";
import { useDispatch, useSelector } from "react-redux";

import { useLocalStorage } from "../../../../hooks";
import { userState } from "../../../../redux/reducers/userReducer";


import { useLocation, useNavigate } from "react-router-dom";
import BZLogo from "../../../../components/BZLogo";
import { TwInputGroup, TwMainLayout, TwSelectGroup, TwWizard } from "../../../../components/tailwind";
import { useToast } from "../../../../provider/ToastProvider";
import { loadingState, setActionLoading, setGlobalLoading } from "../../../../redux/reducers/loadingReducer";
import { getUrlForBookings, getUrlForUsers } from "../../../../utils/confighelpers";

import { OnBordingBaseLayout } from "..";
import axiosInstance from "../../../../utils/axiosInstance";
import { isValidEmail } from "../../../../helpers";
import { useTranslation } from "react-i18next";

export default function StripPaymentOnBording({ navigation }) {
  const { t, i18n } = useTranslation();
  const { addToast, addSuccessToast, addErrorToast, addNotificationDialog, closeNotificationDialog } = useToast();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loadingReduxState = useSelector(loadingState);
  const userReduxState = useSelector(userState);
  const [userToken, setUserToken] = useLocalStorage("userToken");
  const stateValue = userReduxState && userReduxState.onBoardingData && Object.keys(userReduxState.onBoardingData).length > 0 ? userReduxState.onBoardingData : (location.state !== null ? location.state : null)
  const [onBoardingState, setOnBoardingState] = React.useState(
    {
      ...stateValue,
    });
  /********** */

  const bodyData = {
    businessId: "",
    isEnabled: false,
    accountHolderName: "",
    appToken: "",
    paymentType: "Tikkie",
    addedByUserId: userReduxState.userData?._id,
    profileDetails: {
      accountHolderName: "",
      appToken: "",
    },
  };
  const stripeBodyData = {
    businessId: "",
    isEnabled: false,
    paymentType: "Stripe",
    profileDetails: {},
    stripeDetails: {
      // }
    },
    addedByUserId: userReduxState.userData?._id,
  };

  const [formValues, setFormValues] = React.useState(bodyData);
  const [stripeFormValues, setStripeFormValues] = React.useState(stripeBodyData);
  const [isEditStripe, setIsEditStripe] = React.useState(false);
  const [isThereStripeChange, setIsThereStripeChange] = React.useState(true);
  
  const [stripOnbordingFormValues, setStripOnbordingFormValues] = React.useState({
    email: userReduxState?.userData?.myBusinessProfile?.workEmail || "",
    country: "NL",
  });
  const [stripOnbordingFormErrors, setStripOnbordingFormErrors] = React.useState({});
  const [countryOpts, setEventCategoryOpts] = React.useState([
    { iso: "US", name: "United States" },
    { iso: "GB", name: "United Kingdom" },
    { iso: "NL", name: "Netherlands" },
    { iso: "IN", name: "India" },
    { iso: "AE", name: "UAE" },
  ]);

  const getPaymentProfile = async (loading = true) => {
    dispatch(setGlobalLoading(loading));
    const manageClassesConfig = {
      method: "get",
      // url: `${getUrlForClasses()}getPaymentProfile?to=all&teacherID=${userReduxState.userData?._id}`,
      url: `${getUrlForUsers()}getUserInfo`,
    };
    const manageClassesRequest = await axiosInstance(manageClassesConfig);
    dispatch(setGlobalLoading(false));
    if (manageClassesRequest.status === 200) {
      if (manageClassesRequest.data.statusCode === 403) {
        // setWarningText(manageClassesRequest.data.message.errors ? t("errors.somethingIsWrong") : manageClassesRequest.data.message);
        setFormValues(bodyData)
      } else if (manageClassesRequest.data.statusCode === 200) {
        // if (manageClassesRequest.data.data.paymentType === "Stripe") {

        if (manageClassesRequest.data.data?.myConnectedPaymentProfiles?.stripe) {
          let stripeprofileDetails = manageClassesRequest.data.data.myConnectedPaymentProfiles.stripe
          // setIsEditStripe(true);
          setIsEditStripe(stripeprofileDetails?.profileDetails?.stripeAcId && stripeprofileDetails.profileDetails.stripeAcId !== "");
          setStripeFormValues({
            // businessId: manageClassesRequest.data.data._id,
            businessId: null,
            isEnabled: stripeprofileDetails.isEnabled,
            paymentType: "Stripe",
            // stripeDetails: manageClassesRequest.data.data.stripeDetails,
            // stripeDetails: {
            profileDetails: {
              ...stripeprofileDetails.profileDetails,
              stripeAcId: stripeprofileDetails?.profileDetails?.stripeAcId || "",
              stripeEmail: stripeprofileDetails?.profileDetails?.stripeEmail || "",
              stripeCountry: stripeprofileDetails?.profileDetails?.stripeCountry || "",
              stripeOnBoardindStatus: stripeprofileDetails?.profileDetails?.stripeOnBoardindStatus || "",
              paymentMethod: {
                ...stripeprofileDetails.profileDetails?.paymentMethod,
                ideal: stripeprofileDetails.profileDetails?.paymentMethod?.ideal?.enable ? stripeprofileDetails.profileDetails?.paymentMethod?.ideal : { enable: false, chargeToCustomer: false },
                applePay: stripeprofileDetails.profileDetails?.paymentMethod?.applePay?.enable ? stripeprofileDetails.profileDetails?.paymentMethod?.applePay : { enable: false, chargeToCustomer: false },
                googlePay: stripeprofileDetails.profileDetails?.paymentMethod?.googlePay?.enable ? stripeprofileDetails.profileDetails?.paymentMethod?.googlePay : { enable: false, chargeToCustomer: false },
                creditCard: stripeprofileDetails.profileDetails?.paymentMethod?.creditCard?.enable ? stripeprofileDetails.profileDetails?.paymentMethod?.creditCard : { enable: false, chargeToCustomer: false },
              },
            },
            addedByUserId: userReduxState.userData?._id,
          })
          setIsThereStripeChange(true)

          if (stripeprofileDetails?.profileDetails?.stripeAcId && stripeprofileDetails?.profileDetails?.stripeAcId !== "" && stripeprofileDetails?.profileDetails?.stripeOnBoardindStatus == "SUCCESS") {
            window.location.href = "/home/dashboard";
            return;
          }
        }
      }
    }
    dispatch(setGlobalLoading(false));
  };

  const createStripConnectedAC = async (body) => {
    const managemanageStripConnectedACConfig = {
      method: "post",
      url: `${getUrlForBookings()}payments/createConnectedAC`,
      data: {
        ...body,
        // return_url: `${window.location.origin}/my-account/online-payment`,
        return_url: `${window.location.origin}/home/dashboard`,
      },
    };
    dispatch(setGlobalLoading(true));
    dispatch(setActionLoading(true));
    const manageStripConnectedAC = await axiosInstance(managemanageStripConnectedACConfig);
    // dispatch(setGlobalLoading(false));
    // dispatch(setActionLoading(false));
    if (manageStripConnectedAC.status === 200) {
      if (manageStripConnectedAC.data.statusCode === 200) {
        if (manageStripConnectedAC.data?.data?.on_boarding_url && manageStripConnectedAC.data.data.on_boarding_url !== "") {

          // var childStripeWindow = window.open(manageStripConnectedAC.data.data.on_boarding_url, 'Stripe Onboarding', 'toolbar=0,status=0,width=800,height=600');
          window.location = manageStripConnectedAC.data.data.on_boarding_url;
          return;
          // var childStripeWindow = window.open(manageStripConnectedAC.data.data.on_boarding_url, "_blank");


          // }
          // }

          // var timer = setInterval(function () {

          //   }
          // }
        } else {
          addNotificationDialog({
            dialogType: "error",
            dialogTitle: t("errors.errorOccurredTitle"),
            dialogMessage: (manageStripConnectedAC.data.message || "Failed to create Stripe account: Could not verify provided information. Please check your details and try again."),
            dialogBtnTitle: t("errors.errorOccurredBtn"),
          })
        }
      }
    }
  };

  React.useEffect(() => {
    getPaymentProfile(false);
  }, []);

  return (
    <TwMainLayout fullScreen={true}>
      <OnBordingBaseLayout
        title={<BZLogo  className={"!max-h-12 h-auto sm:!w-auto"}/>}
        logoutCallBack={() => { }}
      >
        <div className="min-h-screen flex items-start justify-center 1bg-gray-100 w-full">
          <TwWizard
            className=""
            showSteps={false}
            steps={[
              {
                id: 1,
                name: "Organization Details",
                showSkip: true,
                finishBtnText: "Add payment account",
                onSkipClick: async () => {
                  window.location.href = "/home/dashboard";
                  return true;
                },
                onNextClick: async () => {
                  // window.location.href = "/home/dashboard";
                  // return;
                  const errors = {};
                  if (!stripOnbordingFormValues.email) {
                    errors.email = t("errors.required");
                  } else if (stripOnbordingFormValues.email.length > 0 && isValidEmail(stripOnbordingFormValues.email) === false) {
                    errors.email = t("errors.enterValidEmail");
                  }
                  if (!stripOnbordingFormValues.country) {
                    errors.country = t("errors.required");
                  }
                  setStripOnbordingFormErrors(errors)
                  if (Object.keys(errors).length === 0) {
                    await createStripConnectedAC(stripOnbordingFormValues);
                  }

                  return true
                },
                content: (<div className={"flex flex-col justify-center items-center"}>
                  <div className={"flex flex-col justify-center items-center gap-5 w-full sm:w-full sm:max-w-sm md:max-w-lg"}>
                    <div className="w-full flex flex-col justify-start">
                      <h2 className="text-xl font-semibold">Enable Online Payments</h2>
                      <p className="mt-1 text-sm/6 text-gray-400">You need to activate your payment account before you can start selling your paid tickets </p>
                    </div>
                    {stripeFormValues?.profileDetails?.stripeAcId && stripeFormValues?.profileDetails?.stripeAcId !== "" && stripeFormValues?.profileDetails?.stripeOnBoardindStatus == "SUCCESS" ? (
                      <></>) : (
                      <>
                        <TwInputGroup
                          label={t("inputFieldsTitle.email")}
                          name={"email"}
                          type={"email"}
                          placeholder={t("inputFieldsTitle.email")}
                          // leftIcon={(<img className={""} src={customer_name} alt={""} />)}
                          value={stripOnbordingFormValues.email}
                          onChange={(event) => {
                            setStripOnbordingFormValues((prevValues) => ({
                              ...prevValues,
                              email: event.target.value,
                            }));
                          }}
                          errors={stripOnbordingFormErrors}
                        />
                        <TwSelectGroup
                          label={t("profile.country")}
                          placeholder={t("profile.selectCountry")}
                          name={"country"}
                          // leftIcon={(<img className={""} src={customer_name} alt={""} />)}
                          options={countryOpts.map((country, idx) => {
                            return { value: country.iso, title: country.name }
                          })}
                          defaultValue={countryOpts[2]}
                          value={stripOnbordingFormValues.country}
                          onChange={(event) => {
                            setStripOnbordingFormValues((prevValues) => ({
                              ...prevValues,
                              // country: event.target.value.iso,
                              country: event.target.value,
                            }));
                          }}
                          errors={stripOnbordingFormErrors} />
                      </>

                    )}
                  </div>
                </div>)
              },
            ]}
          />
        </div>
      </OnBordingBaseLayout>
    </TwMainLayout>)
}
